module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionRscj.9393ede5.png";